<script lang="ts">
  import * as _ from "lodash";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import type { CartProduct } from "@shared/types/ProductLine";
  import type { DistributorCart } from "@shared/types/Distributor";
  import {
    getContainerCountString,
    getOrderContainerCounts,
  } from "@retailer/services/order_quantities_service";

  export let products: CartProduct[];
  export let total: any;
  export let isMobile: boolean;
</script>

<section class="fizz-align-self-center fizz-full-width">
  <div data-testid="order-price-section" class="fizz-stack">
    <strong
      class="fizz-text-strong fizz-flex-row"
      class:fizz-justify-end={!isMobile}
      id="total-price-section"
    >
      {#if products.every(p => p.requested_item) || total}
        <FormatMoney input={total} formatType="5" />
      {:else}
        Price not available
      {/if}
    </strong>
    <p class="fizz-text-small fizz-text-subdued fizz-flex-row" class:fizz-justify-end={!isMobile}>
      {getContainerCountString(getOrderContainerCounts(products))}
    </p>
  </div>
</section>
